/* unplugin-vue-components disabled */import { render } from "./NineGridMirrorInferenceRender.vue?vue&type=template&id=6780c57a&scoped=true"
import script from "./NineGridMirrorInferenceRender.vue?vue&type=script&lang=js"
export * from "./NineGridMirrorInferenceRender.vue?vue&type=script&lang=js"

import "./NineGridMirrorInferenceRender.vue?vue&type=style&index=0&id=6780c57a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6780c57a"]])

export default __exports__